import { useEffect } from "react";
import Swal from "sweetalert2";
import { useStore } from "../store";
import { updateInfo, deleteInfo } from "../info";
import { AnnouncementIcon } from "./AnnouncementIcon";
import { AnnouncementText } from "./AnnouncementText";

const style = {
  cursor: "pointer",
  display: "flex",
  backgroundColor: "#F0F0F0",
  border: 0,
  borderBottomLeftRadius: 12,
  borderBottomRightRadius: 12,
  outline: "solid 1px #C0C0C0",
  gap: 6,
  alignItems: "center",
  justifyContent: "center",
  height: 48
};

export function AnnouncementButton() {
  const { announcement, announceUntil, setAnnouncement } = useStore();

  useEffect(() => {
    fetch(process.env.REACT_APP_API + "/announcement/data").then(res => res.json()).then(setAnnouncement);
  }, [ setAnnouncement ]);

  function onAnnouncementClick(e) {
    const announceUntilDate = new Date((announceUntil ?? (Date.now() + 1000*60*60)) + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));
    announceUntilDate.setUTCMinutes(0, 0, 0);

    Swal.fire({
      title: "공지사항 관리",
      html: [
        `<input id="swal2-text" type="text" class="swal2-input" value="${announcement || ""}" placeholder="공지사항">`,
        `<input id="swal2-until" type="datetime-local" class="swal2-input" value="${announceUntilDate.toISOString().slice(0, -1)}">`
      ].join(""),
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "등록",
      denyButtonText: "삭제",
      cancelButtonText: "취소",
      icon: "info",
      preConfirm: () => new Promise((resolve) => resolve({
        text: document.getElementById("swal2-text").value,
        until: Date.parse(document.getElementById("swal2-until").value + "Z") - parseInt(process.env.REACT_APP_TIMEZONE_OFFSET)
      }))
    }).then(async result => {
      if (result.isConfirmed) {
        updateInfo("/announcement/data", result.value, "공지사항", () => setAnnouncement(result.value));
      } else if (result.isDenied) {
        deleteInfo("/announcement/data", "공지사항", () => setAnnouncement(null));
      }
    });
  }

  return (<>
    <button style={ style } onClick={ onAnnouncementClick }>
      <AnnouncementIcon/>
      <AnnouncementText text={
        announcement ?
          (announceUntil >= Date.now() ? announcement : <s>{ announcement }</s>) :
          "공지사항을 등록해주세요."
      }/>
    </button>
  </>);
}
